import React from 'react'
import { Grid } from '@mui/material'
import FieldAutocompleteRegistration from '~/components/FieldAutocompleteRegistration'
import FilterSelectPeriod from '~/components/FilterAutocompletePeriod'
import IDrugType from '~/features/DrugType/interfaces/IDrugType'
import IDrugSituation from '../Interface/IDrugSituation'
import IDestination from '~/features/Destination/interfaces/IDestination'
import { State } from '@hookstate/core'

interface DrugFiltersProps {
  readonly drugType: State<IDrugType | null>
  readonly drugSituation: State<IDrugSituation | null>
  readonly destinationDrugId: State<IDestination | null>
  readonly getDestinations: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly getDrugTypes: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly getCircunstances: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly translate: (key: string) => string
  readonly disableFields?: boolean
  readonly setStartDate: (date: string | null) => void
  readonly setFinishDate: (date: string | null) => void
  readonly initialPeriod: State<string>
}

export default function DrugFilters({
  drugType,
  drugSituation,
  destinationDrugId,
  getDestinations,
  getDrugTypes,
  getCircunstances,
  translate,
  disableFields,
  setStartDate,
  setFinishDate,
  initialPeriod,
}: DrugFiltersProps) {
  return (
    <Grid container spacing={1}>
      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          valueId={drugType.get()?.id as string}
          label={translate('Drug Type')}
          onValueChange={(value) => drugType.set(value)}
          disabled={disableFields}
          optionsFetch={getDrugTypes}
        />
      </Grid>
      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          valueId={drugSituation.get()?.id as string}
          label={translate('Situation')}
          onValueChange={(value) => drugSituation.set(value ?? null)}
          disabled={disableFields}
          optionsFetch={getCircunstances}
        />
      </Grid>
      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          label={translate('Destination')}
          onValueChange={(destination) => destinationDrugId.set(destination)}
          valueId={destinationDrugId.get()?.id as string}
          optionsFetch={getDestinations}
          disabled={disableFields}
        />
      </Grid>
      <FilterSelectPeriod
        required
        onStartDateChange={(value) => setStartDate(value?.toJSON() ?? null)}
        onFinishDateChange={(value) => setFinishDate(value?.toJSON() ?? null)}
        onPeriodChange={(value) => initialPeriod.set(value)}
        period={initialPeriod.get()}
        sxPeriod={{ pl: 0, pt: 0 }}
        sxInitialDate={{ pl: 1, pt: 0 }}
        sxFinalDate={{ pl: 1, pt: 0 }}
      />
    </Grid>
  )
}
